import { SportEventsActionTypes, SignalRTypes } from '.'

export function loadSportEvents(request) {
	return {
		type: SignalRTypes.SportEvents_Request,
		request
	}
}

export function loadKironEvents(request) {
	return {
		type: SignalRTypes.KironSportEvents_Request,
		request
	}
}
export function getKironEvent(request) {
	return {
		type: SignalRTypes.KironEvent_Request,
		request
	}
}

export function clearSportEvents() {
	return {
		type: SignalRTypes.SportEvents_Clear,
	}
}

export function loadSportEventsByDate(request) {
	return {
		type: SignalRTypes.SportEvents_By_Date_Request,
		request
	}
}

export function loadTopBets(request) {
	return {
		type: SignalRTypes.TopBets_Request,
		request
	}
}

export function loadAllBetTypes(request) {
	return {
		type: SignalRTypes.AllBetTypes_Request,
		request
	}
}

export function setEvent(item) {
	return {
		type: SportEventsActionTypes.Set_Event,
		item
	}
}

export function onDropDownsChange(selectedValues) {
	return {
		type: SportEventsActionTypes.SportEvents_OnDropDownsChange,
		selectedValues: selectedValues
	}
}
export function onMobileBetFilterClick(selectedValue) {
	return {
		type: SportEventsActionTypes.SportEvents_OnMobileBetFilterClick,
		selectedValue: selectedValue
	}
}

export function init(){
	return {
		type: SportEventsActionTypes.Init
	}
}

export function getWeekMatchDays(request){
	return {
		type: SportEventsActionTypes.Sport_Get_Week_Match_Days_Request,
		request
	}
}
export function getDefaultLiveSportType(){
	return {
		type: SportEventsActionTypes.Get_Default_Live_Sport_Type_Request,
	}
}
export function filterSportEvents(filterType){
	return {
		type: SportEventsActionTypes.Filter_Sport_Events_Action,
		filterType,
	}
}
export function updateFavoriteSportEvents( tournamentUId){
	return {
		type: SportEventsActionTypes.Update_Favorite_Sport_Events,
		tournamentUId
	}
}
export function updateFavoriteTeamForSportEvents(teamId , isFavorite , teamType){
	return {
		type: SportEventsActionTypes.Update_Favorite_Team_For_Sport_Events,
		teamId,
		isFavorite,
		teamType
	}
}
export function updateFavoriteCountryForSportEvents(sportCategoryUId){
	return {
		type: SportEventsActionTypes.Update_Favorite_Country_For_Sport_Events,
		sportCategoryUId
	}
}